import { render } from "./App.vue?vue&type=template&id=c4c74bcc"
const script = {}

import exportComponent from "/Users/philippschurig/PhpstormProjects/plenty_analytics_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__